import { apiCall } from "../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);

export const getProductDetailsApi = async (id) => {
  try {
    return await get(`get_product_detail/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const submitPOAPI = async (body) => {
  try {
    return await post("purchase_order", body);
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updatePOAPI = async (id, body) => {
  try {
    return await put(`purchase_order/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getPOEditApi = async (id) => {
  try {
    return await get(`purchase_order/edit/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const submitCategoryApi = async (body) => {
  try {
    return await post("category", body);
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
